import { mapActions, mapState } from 'vuex'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'CartMixin',
  computed: {
    cartItems() {
      const _items = []
      this.cart.items.forEach(item => {
        _items.push(item)
        if (Array.isArray(item.warranty)) {
          item.warranty.forEach(witem => {
            const w = witem.split(';')
            _items.push({
              isWarranty: true,
              price: w[2],
              priceUsd: 0,
              name: w[1],
              id: w[0],
              qty: 1,
              // img
              // link
            })
          })
        }
        if (
          Array.isArray(item.profitableKit) &&
          item.profitableKit.length > 1
        ) {
          //console.log(item,'item')
          _items.push(
            this.makeProfitItem(item.profitableKit[0], item.qty, item.kitDisc)
          )
          _items.push(
            this.makeProfitItem(item.profitableKit[1], item.qty, item.kitDisc)
          )
        }
      })
      return _items
    },
    ...mapState(['cart', 'category', 'categories', 'lang']),
  },
  methods: {
    makeProfitItem(product, qty, kit) {
      console.log(kit, 'makeProfitItem')
      let price = product.newPrice ? product.newPrice : product.price
      if (kit) {
        price = Math.ceil(price - price * (kit / 100))
      } else {
        price = Math.ceil(price * 0.8)
      }
      let priceUsd = product.newPriceUsd
        ? product.newPriceUsd
        : product.priceUsd
      if (kit) {
        priceUsd = Math.ceil(priceUsd - priceUsd * (kit / 100))
      } else {
        priceUsd = Math.ceil(priceUsd * 0.8)
      }

      let item = {
        isProfit: true,
        id: product._id,
        qty,
        price,
        priceUsd,
        img: product.img,
        name: product[`name_${this.$i18n.locale}`] || product.name || '',
        link: this.productLink(product),
        warranty: [],
        categoryPath: product.parentCategory || '',
      }
      return item
    },
    productLink(product) {
      try {
        let _c = [...this.categories]
        const { childCategory, parentCategory, slug } = product
        const cc = Array.isArray(childCategory)? childCategory.toString() : childCategory
        const refPath = `${parentCategory}/${cc.replace(',', '/')}`
        let categoryPath = ''
        const chain = refPath.split('/')
        chain.forEach(p => {
          if (!_c) return
          let c = _c.find(c => c.id === p)
          if (c) {
            _c = c.children || null
            if (categoryPath !== '') categoryPath += '/'
            categoryPath += c.slug
          }
        })
        const link = '/product/' + categoryPath + '/' + slug

        return this.lang
          ? '/' + this.lang + link
          : link
      } catch (error) {
        console.log('[productLink]', error.message)
        return `/product/${product.id}`
      }
    },
    productImg(product) {
      return Array.isArray(product.img) && product.img.length
        ? `/img${product.img[0]}`
        : product.img
        ? `/img${product.img}`
        : '/img/uploads/error.png'
    },
    productName(product) {
      return product[`name_${this.$i18n.locale}`]
        ? product[`name_${this.$i18n.locale}`]
        : product.name
        ? product.name
        : ''
    },
    onRemoveItem(item) {
      const item_list_id = uuidv4()
      let listcat_full = this.categoryName(item)
      this.$gtag.event('remove_from_cart', {
        items: [
          {
            item_name: item['name'],
            item_id: item['did'],
            price: item['newPrice'] ? item['newPrice'] : item['price'],
            currency: 'UAH',
            item_brand: 'Apple',
            item_category: listcat_full,
            item_list_name: 'Category',
            item_list_id,
            quantity: item.qty || 1,
          }
        ],
      })
      this.removeFromCart(item.id)
    },
    categoryName(product) {
      let path = ''
      let chain = product.categoryPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach(p => {
        if (!_c) return
        let c = _c.find(c => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c[`name_${this.$i18n.locale}`]
        }
      })
      return path
    },
    ...mapActions(['removeFromCart', 'setCartItemQty', 'removeWarranty']),
  },
}
